module.exports = __webpack_public_path__ + "static/media/add-stack.2ab13f3c.png";